export const LimitFiles = {
  'DEFAULT': 1,
  'MULTIPLE_FILES': 100
};

/**
 * Documentos que vienen pre-cargados desde el onboarding
 */
export const LoanDocsPreloaded = [
  'term_sheet',
  'pre_approval'
];

/**
 * Mapeo de keys de documentos a propiedades en loan.onboarding
 */
export const docKeyOnboarding: Record<string, string> = {
  'term_sheet': 'termSheetURL',
  'pre_approval': 'preApprovalLetterUrl'
};

/**
 * Mapeo de documentos a sus tasks relacionados
 */
export const keyRefLoanDocToTask: Record<string, string> = {
  'appraisal': 'pay_appraisal',
  'title': 'title_company',
  'insurance': 'insurance'
};

/**
 * Documentos que tienen checkboxes deshabilitados para "Hide from borrower"
 */
export const checkDisabled = [
  'credit_report',
  'background_check',
];

export const hiddenCheckboxDisabled = [
  'term_sheet',
  'pre_approval'
];